module.exports = __webpack_public_path__ + "assets/images/JMDUNFIT100.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/JMDUNFIT100.png
// module id = 1402
// module chunks = 1